
import { defineComponent } from 'vue';
import router from '@/router';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src

export default defineComponent({
  name: 'HomeView',
  components: {
    HelloWorld,
  },
  mounted() {
    router.push({ path: '/login' });
  }
});
